
import Maker from "../../../assets/outline/Maker.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function MakerIcon({ className, dataTestid = "MakerIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Maker data-testid={dataTestid} className={classes} {...rest} />
  );
}
